import React from "react";
import { Link, withRouter } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { Breadcrumb, Header, Loader, Label } from "semantic-ui-react";
import { DELETE_STUDENT, UPDATE_STUDENT, GET_EDIT_STUDENT } from "../GraphQL";
import StudentForm from "../components/StudentForm";

const EditStudentPage = ({ match, history }) => {
  const { error, loading, data } = useQuery(GET_EDIT_STUDENT, {
    variables: { id: match.params.id },
  });
  const [updateStudent] = useMutation(UPDATE_STUDENT);
  const [deleteStudent] = useMutation(DELETE_STUDENT);

  if (loading) {
    return <Loader active />;
  }
  if (error) {
    throw error;
  }
  const student = data.getStudent;
  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/">Home</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>
          <Link to={`/students/${student.id}`}>{student.name}</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section active>Edit Student</Breadcrumb.Section>
      </Breadcrumb>

      <Header as="h2" dividing>
        {student.name}{" "}
        {student.archived ? <Label color="grey">Archived</Label> : false}
      </Header>

      <StudentForm
        student={student}
        isNewStudent={false}
        onSubmit={async (input) => {
          await updateStudent({
            variables: { id: match.params.id, input },
          });
          history.push(`/students/${match.params.id}`);
        }}
        onCancel={() => history.push(`/students/${student.id}`)}
        onDelete={() => {
          deleteStudent({
            variables: { id: match.params.id },
            onCompleted: () => history.push("/students"),
            update: (cache, { data: { deleteStudent } }) => {
              console.log("update", deleteStudent);
              cache.modify({
                fields: {
                  myStudents(existingStudents = [], { readField }) {
                    existingStudents.filter(
                      (s) => readField("id", s) !== match.params.id
                    );
                  },
                },
              });
            },
          });
        }}
      />
    </div>
  );
};

export default withRouter(EditStudentPage);
